export default "__VITE_ASSET__CmNd8pex__"